/*
 * Mobile nav analytics. dataLayer pushes only:
 *   nav_open    - menu drawer opened (nav_open_type "menu") or a dropdown expanded ("dropdown")
 *   nav_click   - a link in the drawer, or the sticky CTA button (nav_item_level "sticky_cta")
 *   nav_dismiss - menu drawer closed without any link being clicked
 * These reach GA4 only through GTM-KMRTRLM's "Event - nav_*" Custom Event triggers and
 * "GA4 Event - nav_*" tags; a push with no matching trigger/tag collects nothing.
 *
 * Labels, levels and positions are read from the DOM rather than from markup added for
 * tracking, so the same script works on the classic drawer and the accordion redesign
 * (A/B control and variant). Every push sends every key, because GTM's data model keeps
 * keys from earlier pushes and a sub-item's nav_parent_label would otherwise leak into
 * the next top-level click.
 */
(function () {
  const drawer = document.querySelector('header-drawer');
  const navVersion = drawer?.dataset.navVersion || '';
  let clickedSinceOpen = false;

  function push(event, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      nav_location: 'mobile',
      nav_version: navVersion,
      nav_open_type: '',
      nav_item_label: '',
      nav_item_level: '',
      nav_item_position: '',
      nav_parent_label: '',
      nav_destination: '',
      ...params,
    });
  }

  function cleanText(element) {
    return (element?.textContent || '').replace(/\s+/g, ' ').trim();
  }

  // Path only, no query string or hash, to keep GA4 cardinality down. Off-site links keep
  // their host so e.g. the order.online pickup link stays distinguishable.
  function destinationPath(href) {
    try {
      const url = new URL(href, window.location.origin);
      return url.origin === window.location.origin ? url.pathname : url.host + url.pathname;
    } catch (error) {
      return '';
    }
  }

  function positionInList(element) {
    const item = element.closest('li');
    if (!item || !item.parentElement) return '';
    return String(Array.prototype.indexOf.call(item.parentElement.children, item) + 1);
  }

  if (drawer) {
    const container = drawer.querySelector('#Details-menu-drawer-container');

    // `toggle` doesn't bubble, so listen in the capture phase to see the container and every
    // nested <details> from one place, however they were opened or closed.
    drawer.addEventListener(
      'toggle',
      (event) => {
        const details = event.target;
        if (details === container) {
          if (details.open) {
            clickedSinceOpen = false;
            push('nav_open', { nav_open_type: 'menu', nav_item_label: 'Menu' });
          } else if (!clickedSinceOpen) {
            push('nav_dismiss', {});
          }
          return;
        }

        if (!details.open || !container?.open) return;
        const summary = details.querySelector(':scope > summary');
        push('nav_open', {
          nav_open_type: 'dropdown',
          nav_item_label: cleanText(summary),
          nav_item_level: 'top',
          nav_item_position: positionInList(details),
        });
      },
      true
    );

    drawer.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || !drawer.querySelector('.menu-drawer__navigation')?.contains(link)) return;

      clickedSinceOpen = true;
      const parentDetails = link.closest('details:not(#Details-menu-drawer-container)');
      push('nav_click', {
        nav_item_label: cleanText(link.querySelector('.menu-drawer__accordion-label') || link),
        nav_item_level: parentDetails ? 'sub' : 'top',
        nav_item_position: positionInList(link),
        nav_parent_label: parentDetails ? cleanText(parentDetails.querySelector(':scope > summary')) : '',
        nav_destination: destinationPath(link.href),
      });
    });
  }

  // The sticky CTA points at the same page as the top-level "Shop All" item, so it is tagged
  // with its own level to keep CTA entries separable from menu entries.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('#sticky-cta-button a[href]');
    if (!link) return;
    push('nav_click', {
      nav_location: window.matchMedia('(max-width: 989px)').matches ? 'mobile' : 'desktop',
      nav_item_label: cleanText(link),
      nav_item_level: 'sticky_cta',
      nav_destination: destinationPath(link.href),
    });
  });
})();
